/* eslint-disable class-methods-use-this */
import { ChangeLanguagaInput } from './dto/changeLanguageInput';
import { CreateOrUpdateUserInput } from './dto/createOrUpdateUserInput';
import { EntityDto } from '../dto/entityDto';
import { GetAllUserOutput } from './dto/getAllUserOutput';
import { PagedResultDto } from '../dto/pagedResultDto';
import { PagedUserResultRequestDto } from './dto/PagedUserResultRequestDto';
import http from '../httpService';
import { ChangePasswordInput } from './dto/changePasswordInput';
import { ProfileLogoInput } from 'services/tenant';

class UserService {
  public async create(createUserInput: CreateOrUpdateUserInput) {
    const result = await http.post('api/services/app/User/Create', createUserInput);
    return result.data.result;
  }

  public async update(updateUserInput: CreateOrUpdateUserInput) {
    const result = await http.put('api/services/app/User/Update', updateUserInput);
    return result.data.result;
  }

  public async delete(entityDto: EntityDto) {
    const result = await http.delete('api/services/app/User/Delete', { params: entityDto });
    return result.data;
  }

  public async getRoles() {
    const result = await http.get('api/services/app/User/GetRoles');
    return result.data.result.items;
  }

  public async changeLanguage(changeLanguageInput: ChangeLanguagaInput) {
    const result = await http.post('api/services/app/User/ChangeLanguage', changeLanguageInput);
    return result.data;
  }

  public async get(entityDto: EntityDto): Promise<CreateOrUpdateUserInput> {
    const result = await http.get('api/services/app/User/Get', { params: entityDto });
    return result.data.result;
  }

  public async getAll(
    pagedFilterAndSortedRequest: PagedUserResultRequestDto
  ): Promise<PagedResultDto<GetAllUserOutput>> {
    const result = await http.post('api/services/app/User/GetAll', pagedFilterAndSortedRequest);
    return result.data.result;
  }

  public async changePassword(changePasswordInput: ChangePasswordInput) {
    const result = await http.post('api/services/app/User/ChangePassword', changePasswordInput);
    return result.data;
  }

  public async updateLogo(input: ProfileLogoInput) {
    const result = await http.put('api/services/app/User/UpdateLogo', input);
    return result.data.result;
  }

  public async deleteLogo() {
    await http.delete('api/services/app/User/DeleteLogo');
  }

  public async updateCalendarViewSetting(value: string) {
    await http.put('api/services/app/User/UpdateCalendarViewSetting', { value });
  }

  public async forceSetTwoFactor(userId: number, enabled: boolean): Promise<void> {
    await http.post('api/services/app/User/ForceSetTwoFactor', { userId, enabled });
  }
}

export default new UserService();
